import { FuseAlertType } from "@fuse/components/alert";

export enum NotificationClassEnum {
  SUCCESS = "success-notification",
  ERROR = "error-notification",
  INFO = "info-notification",
  WARNING = "warning-notification"
}
export enum NotificationType {
  WARNING = "alert-warning",
  ERROR = "alert-danger",
  INFO = "alert-info"
}
export interface NotificationBanner {
  message: string;
  type: FuseAlertType
}